<template>
    <component :is="tag" v-if="text" class="s-side-menu-control__group">
        <a-glyph
            v-if="glyph"
            :name="glyph"
            class="s-side-menu-control__group-icon"
        />
        <span class="s-side-menu-control__group-title">{{ text }}</span>
    </component>
</template>

<script setup>
import AGlyph from '@core/components/glyph/glyph.vue';

defineProps({
    text: {
        type: String,
        default: null,
    },
    glyph: {
        type: String,
        default: null,
    },
    tag: {
        type: String,
        default: 'li',
    },
});
</script>
